export default "__VITE_ASSET__54db70fd__"